<template>
  <div>
  <span class="send-sms-code" type="text" @click="handleCaptcha" :disabled="Boolean(countDown)" size="small">
    {{ message }}
  </span>
  <!-- 图形验证码弹窗 -->
    <el-dialog
      title="安全验证"
      :visible.sync="captchaVisible"
      v-if="captchaVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
      modal-append-to-body
      append-to-body  
    >
      <p class="captcha-tip">请完成下方验证后发送短信验证码</p>
      
      <div class="captcha-content">
        <div class="captcha-display">
          <el-image
        v-loading="captchaLoading"
        :src="captchaSrc"
        @click="refreshCaptcha"
        style="cursor: pointer; width: 100%; height: auto;"
        fit="contain"
    />
        </div>
        
        <el-form
          ref="captchaForm"
          :model="captchaForm"
          @submit.native.prevent="handleSendSMSCode"
        >
          <el-form-item prop="captcha">
            <el-input
              v-model="captchaForm.captcha"
              placeholder="请输入上方验证码"
              maxlength="5"
              clearable
              @keyup.enter.native="handleSendSMSCode"
            ></el-input>
          </el-form-item>
          
          <div class="captcha-buttons">
            <el-button @click="cancelCaptcha">取消</el-button>
            <el-button
              type="primary"
              @click="handleSendSMSCode"
              :loading="loading"
            >
              验证
            </el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uasSendSMSCode } from "@/api/user/uas"
import { getCaptcha} from '@/api/user/user'
export default {
  name: "SendSmsCode",

  props: {
    telephone: {
      type: String,
      required: true,
      default: "",
    },
    smsType: {
      type: String,
      required: false,
      default: "login",
    },
  },

  data() {
    return {
      message: "获取验证码",
      countDown: 0,
      intervalId: -1,
      loading: false,
      captchaVisible: false,
      captchaLoading: false,
      captchaSrc: "",
      captchaForm: {},
      verifyingCaptcha: false,
    };
  },

  methods: {
    cancelCaptcha(){
      this.captchaVisible=false
      this.captchaForm={}
    },
    handleCaptcha() {
       this.captchaVisible = true
       this.refreshCaptcha()
    },
     async refreshCaptcha() {
      
      this.captchaLoading=true
      try{
        this.captchaForm.random=new Date().getTime()
        const res=await getCaptcha({random:this.captchaForm.random})
        if(res.success){
          this.captchaSrc=res.result
        }else{
          this.$message.error(res.message)
        }
      }catch(error){
        this.$msgError(error.response.message?error.response.message:'获取验证码失败')
      }finally{
        this.captchaLoading=false 
      }
      
    },
    async handleSendSMSCode() {
      if (!this.telephone) {
        this.$message.error("请输入手机号");
        return false;
      }
      if (this.telephone.length !== 11) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
       if(this.smsType==='reg'&&!this.captchaForm.captcha){
            this.$message.error("请输入验证码");
        return false;
      }
      this.loading = true;
      const data = {
        loginName: this.telephone,
        smsType: this.smsType,
        random:this.captchaForm.random,
        code:this.captchaForm.captcha
      }
      try{
       const res=await uasSendSMSCode(data)
       if(res.success){
          this.$message.success('短信已发送')
          this.setCountDown()
            this.captchaVisible=false
            this.captchaForm={}
       }
       else{
         this.$message.error(res.message)
       }
      }catch(error){
        this.$msgError(error.response.message?error.response.message:'获取验证码失败')
      }finally{
        this.loading = false;
      }
    },

    setCountDown() {
      this.countDown = 60;
      this.message = `剩余${this.countDown}s`;
      this.intervalId = window.setInterval(() => {
        --this.countDown;
        this.message =
          this.countDown === 0 ? "获取验证码" : `剩余${this.countDown}s`;
        if (this.countDown === 0) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.send-sms-code {
  margin-right: 8px;
  font-weight: 400;
  color: #46b0e2;
  cursor: pointer;

  .el-button>span {
    color: #46b0e2;
  }
}
/* 图形验证码相关样式 */
.captcha-tip {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
}

.captcha-content {
  text-align: center;
}

.captcha-display {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.captcha-display canvas {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-right: 15px;
  background-color: #f8f9fa;
}
</style>
